<template>
  <a :href="props.url" class="cursor-pointer hover:text-primary-500 inline-block">
    <Flex gap-3 justify-start items-center>
      <IconSolid v-if="props.icon" :icon="props.icon" />
      <slot />
    </Flex>
  </a>
</template>
<script setup>
  const props = defineProps({
    url: String,
    icon: String,
  })
</script>
